// extracted by mini-css-extract-plugin
export default {"wrap":"Sx-z","logoContainer":"Tx-z","brandImg":"Ux-z","logoImg":"Vx-z","logoButton":"Wx-z"};